var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinie03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Linie-03__Icn/40px/Linie-03",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Linie-03__Color/Transp_00",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H40V40H0z",
    id: ".._.._src_svg_Icn_40px_Linie-03__Rectangle"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M12,31 C12,31.1249926 11.9885339,31.2473072 11.9665963,31.3659492 C11.6534323,31.3893775 11.3314458,31.401001 11,31.401001 C10.4477153,31.401001 10,30.9532857 10,30.401001 C10,29.8487162 10.4477153,29.401001 11,29.401001 L11.1987187,29.3988919 C11.6852261,29.7637149 12,30.3450977 12,31 Z M20,23 C20.1789374,23 20.3542159,22.984334 20.5245386,22.9542989 L20.4361667,23.2770203 C19.863196,25.3040032 19.2905188,26.6297174 18.4091087,27.8804627 C17.1210534,29.708249 15.349877,30.8484347 12.9888352,31.2442239 C12.9966753,31.164088 13,31.0824323 13,31 C13,30.375634 12.8092638,29.7958168 12.4828805,29.3156374 C15.5900779,28.9285879 17.1274996,27.1619611 18.3666134,23.1633576 L18.5306871,22.6161643 C18.9649427,22.8605789 19.4661896,23 20,23 Z M20,18 C20.6301297,18 21.1921968,18.2914109 21.5587866,18.7468179 L21.555498,18.7576334 L21.3912367,19.4189522 L20.8942048,21.5196638 L20.8176276,21.8257787 C20.568019,21.9377311 20.2912813,22 20,22 C19.5529753,22 19.1402046,21.8533409 18.8071788,21.6055137 L18.8003158,21.6324466 C18.8286668,21.5238143 18.8569342,21.4138483 18.8851355,21.3025368 L19.0536886,20.6184304 L19.4518362,18.9238813 L19.671161,18.0269041 C19.7781467,18.0092065 19.8879982,18 20,18 Z M26,10 C26,10.6306067 26.1945681,11.2157695 26.5269469,11.6987312 C24.3896345,12.074049 23.2221378,13.425238 22.2176479,16.4527316 L22.0496239,16.9793972 L21.8838313,17.5386039 L21.8546937,17.6418508 C21.3442673,17.2398435 20.7001429,17 20,17 L19.94,17.0018857 L20.0062409,16.7603357 L20.1567186,16.244371 C20.1817379,16.1616086 20.2067529,16.0804007 20.2318025,16.0006551 L20.3828259,15.5389906 L20.5365444,15.1079954 C20.7960239,14.4127697 21.0745034,13.8268963 21.4108371,13.2581937 L21.6198906,12.9182953 C22.6737409,11.2675295 24.1090998,10.2072594 26.0080602,9.78748977 C26.0025004,9.8576102 26,9.9285131 26,10 Z M28,9.58288574 C28.5522847,9.58288574 29,10.030601 29,10.5828857 C29,11.1351705 28.5522847,11.5828857 28,11.5828857 L27.7810756,11.5857558 C27.3060762,11.2200938 27,10.6457908 27,10 C27,9.87271286 27.0118909,9.74820299 27.0346225,9.62752062 C27.3455526,9.59780899 27.6672067,9.58288574 28,9.58288574 Z",
    id: ".._.._src_svg_Icn_40px_Linie-03__Combined-Shape",
    fillRule: "nonzero",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Linie-03__Group-Copy",
    transform: "translate(8 8)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: ".._.._src_svg_Icn_40px_Linie-03__Oval-Copy-5",
    cx: 21,
    cy: 2,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: ".._.._src_svg_Icn_40px_Linie-03__Oval-Copy-4",
    cx: 12,
    cy: 12,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: ".._.._src_svg_Icn_40px_Linie-03__Oval-Copy-3",
    cx: 2,
    cy: 23,
    r: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinie03);
export default __webpack_public_path__ + "static/media/Linie-03.6d9df0630dbfd97f1c9e80a9b2c4da69.svg";
export { ForwardRef as ReactComponent };